import React from 'react';

export default function Component(props) {

  const { question, answersList, ansDMGNPSInput, surveyLanguageCode, surveyScreenData, rowData, isRowComplete } = props;
  // let [showValue, handleValue ] = React.useState(0)

  // let showValue = false;
  // function handleValue(){}


  let rowList = []
  if (question && question.dmgModule && question.dmgModule === "SELF") {
    rowList = rowData && rowData.selfList && rowData.selfList.length > 0 ? rowData.selfList : []
  } else if (question && question.dmgModule && question.dmgModule === "CROSS") {
    rowList = rowData && rowData.crossList && rowData.crossList.length > 0 ? rowData.crossList : []
  }






  let [showValue2, handleValue2] = React.useState(111)

  let showValue = false;
  function handleValue() { }

  function CustomLabels(optionID, optionName, question) {
    let surveyLanguageCode = "customNPS";
    return (surveyLanguageCode !== '') ?
      (question && question.transl &&
        question.transl[surveyLanguageCode] &&
        question.transl[surveyLanguageCode][optionID]) ?
        question.transl[surveyLanguageCode][optionID] : optionName
      : optionName
  }


  function NPSName(optionID, optionName, surveyLanguageCode, question) {

    return (surveyLanguageCode !== '') ?
      (question && question.transl &&
        question.transl[surveyLanguageCode] &&
        question.transl[surveyLanguageCode].optionsList &&
        question.transl[surveyLanguageCode].optionsList[optionID]) ?
        question.transl[surveyLanguageCode].optionsList[optionID] : optionName
      : optionName
  }



  function NPSColor(question) {



    let Color = "#a3a3a3";
    let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    if (showValue) {
      answer = showValue;
    }


    if (answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6) {
      Color = "#2074e3";
      if (answer === 1 || answer === 2) {
        Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied", question), surveyLanguageCode, question)
      }
      else if (answer === 3 || answer === 4) {
        Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied", question), surveyLanguageCode, question)
        console.log('Dissatisfied Name: ', Name)
      }
      else if (answer === 5 || answer === 6) {
        Name = NPSName("Neither", CustomLabels("Neither", "Neither", question), surveyLanguageCode, question)
      }
    }
    else if (answer === 7 || answer === 8) {
      Color = "#2074e3";
      Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied", question), surveyLanguageCode, question)
    }
    else if (answer === 9 || answer === 10) {
      Color = "#2074e3";
      Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied", question), surveyLanguageCode, question)
    }

    return {
      color: Color,
      name: Name
    }
  }


  function NPSColor2(question) {



    let Color = "#a3a3a3";
    let Name = NPSName("Ratehere", "Rate here", surveyLanguageCode, question)
    let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
    if (showValue2 || showValue2 === 0) {
      answer = showValue2;
    }


    if (answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6) {
      Color = "#2074e3";
      if (answer === 1 || answer === 2) {
        Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied", question), surveyLanguageCode, question)
      }
      else if (answer === 3 || answer === 4) {
        Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied", question), surveyLanguageCode, question)
        console.log('Dissatisfied Name: ', Name)
      }
      else if (answer === 5 || answer === 6) {
        Name = NPSName("Neither", CustomLabels("Neither", "Neither", question), surveyLanguageCode, question)
      }
    }
    else if (answer === 7 || answer === 8) {
      Color = "#2074e3";
      Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied", question), surveyLanguageCode, question)
    }
    else if (answer === 9 || answer === 10) {
      Color = "#2074e3";
      Name = NPSName("Extremelysatisfied", CustomLabels("Extremelysatisfied", "Extremely Satisfied", question), surveyLanguageCode, question)
    }

    return {
      color: Color,
      name: Name
    }
  }

  // function matchAnswer(answersList1,question1){
  //   let value = "";
  //   if(answersList1 && answersList1.length>0){
  //     let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
  //     if(getIndex1!==-1){
  //       value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer?answersList1[getIndex1].answer:"";
  //     }
  //   }
  //   return value
  // }

  function getCheckFn(list, quesId, optValue, dmgValue) {
    let check = false;
    if (list && list.length > 0) {
      let getIndex = list.findIndex(prev => prev.questionId.toString() === quesId.toString());
      if (getIndex !== -1) {
        if (list && list[getIndex] && list[getIndex]["multiAnswer"] && list[getIndex]["multiAnswer"].length > 0) {
          let getIndex2 = list[getIndex]["multiAnswer"].findIndex(prev => prev.optionHead.toString() === dmgValue.toString());
          if (getIndex2 !== -1 && (Number(list[getIndex]["multiAnswer"][getIndex2]["optionAns"]) >= Number(optValue))) {
            check = true;
          }
        }

      }
    }
    return check
  }

  let rowListV1 = [];
  if (rowList && rowList.length > 0) {
    let substringToFind = 'Self';
    let sortOrder = rowList.filter(item => item.value.includes(substringToFind));

    rowList.forEach((ele, index) => {
      if (ele.value === (sortOrder && sortOrder[0] && sortOrder[0]["value"] ? sortOrder[0]["value"] : "")) {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": 1
        })
      } else {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": index + 1000
        })
      }
    });

    rowListV1.sort((a, b) => {
      return a.index - b.index;
    });


  }


  return (
    <>

      <div className="overflow-y-auto w-full " id="chatbot" >
        <table className="w-full lg:block hidden ">
          <thead className="">
            <tr>
              <th colSpan={1} className=" text-left py-1 px-4 text-sm   whitespace-pre-line w-[30%]"
                style={{ color: false ? '#e31919' : ((surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : 'black') }}
              >
              </th>
              <th
                colSpan={11}
                className="py-1 px-2 font-semibold text-sm text-center  text-[#212121] break-words w-[70%] ">
                <div className='flex justify-between items-center  '>
                  <p> Not at all likely</p>
                  <p> Extremely likely</p>
                </div>
              </th>

            </tr>

          </thead>
          <tbody className="">
            {rowListV1 && rowListV1.length > 0 ?
              rowListV1.map((row, index) =>
                <tr key={index}>

                  <td colSpan={1} className={"py-1 px-4 text-sm text-right whitespace-pre-line " + (isRowComplete(answersList, row.value, question) ? "text-[#212121]" : "text-red-500")}
                  >
                    {row.value}

                  </td>

                  {question && question.optionsList && question.optionsList.length > 0 ?
                    question.optionsList.map((option, optionindex) =>
                      <td key={optionindex}
                        className="text-center py-1 px-1 w-16" colSpan={1}>
                        {getCheckFn(answersList, question.id, optionindex, row.value) ?
                          <div onClick={() => ansDMGNPSInput(optionindex, question, row)} className='bg-[#2196f3] rounded-md py-2 flex items-center justify-center text-white h-12 cursor-pointer'>
                            {optionindex}
                          </div>

                          :
                          <div onClick={() => ansDMGNPSInput(optionindex, question, row)} className='bg-[#fff] border border-[#212121]/20 rounded-md py-2 h-12 cursor-pointer flex items-center justify-center text-[#212121]/80'>
                            {optionindex}
                          </div>
                        }

                      </td>
                    ) : null}
                </tr>
              ) : null}
          </tbody>
        </table>


        {/* mobile */}
        <div className="lg:hidden block space-y-6"   >

          {rowListV1 && rowListV1.length > 0 ?
            rowListV1.map((row, index) =>
              <div key={index}>
                <p className={"w-full  pb-2 px-0 text-base  whitespace-pre-line font-semibold " + (isRowComplete(answersList, row.value, question) ? "text-[#212121]" : "text-red-500")}>
                  {row.value}
                </p>


                <div className='space-y-2 '>
                  <p className='text-sm text-[#212121]/70'> Not at all likely</p>

                  <div className='grid grid-cols-6 gap-2'>
                    {question && question.optionsList && question.optionsList.length > 0 ?
                      question.optionsList.map((option, optionindex) =>
                        <div key={optionindex}
                          className="text-center " colSpan={1}>
                          {getCheckFn(answersList, question.id, optionindex, row.value) ?
                            <div onClick={() => ansDMGNPSInput(optionindex, question, row)} className='bg-[#2196f3] rounded-md py-2 flex items-center justify-center text-white h-12 cursor-pointer'>
                              {optionindex}
                            </div>
                            :
                            <div onClick={() => ansDMGNPSInput(optionindex, question, row)} className='bg-[#fff] border border-[#212121]/20 rounded-md py-2 h-12 cursor-pointer flex items-center justify-center text-[#212121]/80'>
                              {optionindex}
                            </div>
                          }

                        </div>
                      ) : null}
                  </div>
                  <p className='text-right w-full text-sm text-[#212121]/70'> Extremely likely</p>
                </div>
              </div>
            ) : null}


        </div>
      </div>


    </>
  );
}